import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .row-left {
    margin-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75em;
    line-height: 1.8em;
    margin-bottom: 0.5em;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6em; margin-bottom: 0em;`}
  }

  .row {
    .list-atv {
      margin-top: 1em !important;
    }

    .lateral {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;

      p {
        margin-left: 0.5em;
      }
    }

    .horario {
      margin-top: 1em;
      margin-bottom: 1em;
      display: flex;

      .item-hora {
        display: flex;

        .card-numero {
          background: ${Colors.Color4};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          width: 1.4em;
          height: 1.4em;
          justify-content: center;
          align-items: center;
          margin-left: 0.45em;

          .numero {
            font-size: 0.7em;
            font-weight: 600;
            color: white;
          }
        }

        .card-hora {
          background: ${Colors.Color2};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          height: 1.4em;
          margin-left: 0.45em;
          justify-content: center;
          align-items: center;

          .hora {
            font-size: 0.7em;
            font-weight: 600;
            color: ${Colors.Color4};
            width: 100%;
          }
        }
      }
    }

    .no-padding {
      padding: 0 !important;
    }

    .item {
      h6 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 0.8em;
        line-height: 1.8em;
        margin-bottom: 0em;
        color: ${Colors.Color4};
      }

      h3 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 1em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.Color7};
      }

      h5 {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.Color7};
      }

      p {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.color25};
      }
    }
  }

  .aprov-header {
    width: 100%;
    padding: 0 0.6em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .aprov-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex: 1 1 auto;
      min-width: 0;

      .aprov-cod {
        font-size: 0.85em;
        font-weight: 700;
        color: ${Colors.Color4};
        margin-right: 0.6em;
      }

      h3 {
        font-size: 1.1em;
        font-weight: 600;
        color: ${Colors.Color9};
        margin: 0 0.6em 0 0;
      }

      .badge-tipo {
        font-size: 0.65em;
        font-weight: 600;
        background: ${Colors.Color2};
        border-radius: 1em;
        padding: 0.15em 0.7em;
      }

      .badge-tipo-suporte {
        color: ${Colors.Color4};
        border: 0.06em solid ${Colors.Color4};
      }

      .badge-tipo-projeto {
        color: ${Colors.Color7};
        border: 0.06em solid ${Colors.Color7};
      }
    }

    .badge-status {
      flex: 0 0 auto;
      margin-left: auto;
      font-size: 0.7em;
      font-weight: 600;
      color: ${Colors.color25};
      background: ${Colors.Color2};
      border: 0.12em solid ${Colors.Color7};
      border-radius: 1em;
      padding: 0.2em 0.9em;
      white-space: nowrap;
    }
  }

  .aprov-info-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 0.6em;
    margin-top: 0.8em !important;

    .info-item {
      display: flex;
      flex-direction: column;
      width: 25%;
      margin-bottom: 0.6em;

      .info-label {
        font-size: 0.7em;
        font-weight: 600;
        color: ${Colors.Color7};
        margin-bottom: 0.2em;
      }

      .info-value {
        font-size: 0.85em;
        font-weight: 500;
        color: ${Colors.color25};
      }
    }

    .info-item-destaque {
      background: ${Colors.Color2};
      border-radius: 0.6em;
      padding: 0.5em 0.8em;
      width: calc(25% - 0.6em);

      .info-label {
        color: ${Colors.Color7};
      }

      .info-value {
        font-size: 1.15em;
        font-weight: 700;
        color: ${Colors.Color4};
      }
    }
  }

  .aprov-stats {
    display: flex;
    flex-direction: row;
    gap: 1em;
    padding: 0 0.6em;
    margin-top: 1em !important;
    margin-bottom: 1.2em !important;

    .stat-card {
      flex: 1;
      background: ${Colors.Color2};
      border-radius: 0.6em;
      padding: 0.8em 1em;

      .stat-label {
        font-size: 0.65em;
        font-weight: 700;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        color: ${Colors.Color7};
        margin-bottom: 0.3em;
      }

      .stat-value {
        font-size: 1.4em;
        font-weight: 700;
        color: ${Colors.Color4};
      }
    }
  }

  .titulo-com-badge {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4em;

    .badge-srp,
    .badge-pos {
      font-size: 0.7em;
      font-weight: 600;
      color: ${Colors.Color4};
      background: ${Colors.Color2};
      border: 0.06em solid ${Colors.Color4};
      border-radius: 1em;
      padding: 0.1em 0.6em;
      white-space: nowrap;
    }
  }

  .footer {
    position: fixed;
    bottom: 1em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
    margin-bottom: 1.5em;
    border-radius: 0.4em;
    padding: 0em 1em 0em 1em !important;

    .content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75em;
        margin-bottom: 1.25em;

        .cod {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }
`;

export const SecaoTicket = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.4em;

  .atv-content-body {
    width: 98%;
    background: ${Colors.Color22};
    margin-left: 1%;
    border-radius: 0 0 0.6em 0.6em;
    padding: 1em 0.6em;

    ${props =>
      props?.excluido &&
      `
      opacity: 0.5;
    `}

    .content-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1em;

      .title_p {
        margin: 0;
      }
    }

    .item-desc {
      p,
      div {
        background: ${Colors.Color22} !important;
        color: ${Colors.Color7} !important;
      }
    }

    .item-desc.no-html {
      white-space: pre;
      white-space: pre-line;
      white-space: pre-wrap;
    }

    .item-horario {
      background: ${Colors.Color26};
      border-radius: 0.5em;
      min-height: 2em;
      position: relative;
      margin-bottom: 0.3em;
      padding: 0.2em;

      .col {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0;

        p {
          width: 10em;
          margin: 0;
        }
      }
    }

    .item-horario::before {
      content: '';
      background: ${Colors.Color4};
      height: 60%;
      width: 0.1em;
      position: absolute;
      top: 20%;
      border-radius: 0.4em;
    }
  }
`;

export const ItemTicket = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${props => (props?.item ? Colors.Color26 : Colors.Color4)};
  color: ${props => (props?.item ? Colors.Color7 : Colors.Color9)};
  width: 100%;
  min-height: 2.6875em;
  border-radius: 0.5em;
  margin-bottom: ${props => (props?.item ? '0em' : '0.4em')};
  padding: 0.5em 1em 0.5em 1em;
  cursor: pointer;

  ${props =>
    props?.excluido &&
    `
    opacity: 0.5;

    .text-col {
      text-decoration: line-through;
    }
  `}

  .text-col {
    font-size: 0.8em;
  }
`;
